export { StudentAccountPage } from "./StudentAccountPage"
export type { StudentAccountNotice, StudentAccountPageProps, UIStudentAccountGamification } from "./StudentAccountPage"
